/**
 * Función que retorna la fecha de inicio del mes actual y la fecha de hoy
 * @returns {Object} Objeto con las fechas en formato YYYY-MM-DD
 */
function getDateRange() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    
    return {
      dateInit: formatDate(firstDayOfMonth),
      dateEnd: formatDate(today)
    };
  }
  
export default getDateRange;